import React, { ReactNode } from 'react';
import Skeleton from 'src/components/Skeleton/Skeleton';
import './Heading.scss';

interface IHeadingProps {
  headline: string;
  headlineAction?: ReactNode;
  items?: any[];
  body?: ReactNode;
  children?: ReactNode;
  loading?: boolean;
}

const Heading = ({
  headline,
  headlineAction,
  items,
  body,
  children,
  loading,
}: IHeadingProps) => (
  <div className="heading">
    <div className="heading-headline">
      {headline}
      {headlineAction}
    </div>
    {(children || body) && (
      <div className="heading-body">{children ?? body}</div>
    )}
    {items && (
      <div className="heading-items">
        {items.map((i: any, x: number) => (
          <div key={x} className="heading-item">
            <div className="heading-value">
              {loading ? <Skeleton variant="text" width="2.4rem" /> : i.value}
            </div>
            <div className="heading-key">{i.key}</div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default Heading;
